import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex h-screen items-center justify-center text-neutral-500 text-sm">
        Cargando…
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="flex h-screen items-center justify-center p-8 text-center">
        <div>
          <h2 className="font-display text-2xl mb-2">Acceso restringido</h2>
          <p className="text-neutral-600 text-sm">No tienes permisos para ver esta sección.</p>
        </div>
      </div>
    );
  }
  return children;
}
